/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./compat-abtest.module";
import * as i2 from "./compat-abtest.component.ngfactory";
var CompatABTestModuleNgFactory = i0.ɵcmf(i1.CompatABTestModule, [], function (_l) { return i0.ɵmod([i0.ɵmpd(512, i0.ComponentFactoryResolver, i0.ɵCodegenComponentFactoryResolver, [[8, [i2.CompatABTestComponentNgFactory]], [3, i0.ComponentFactoryResolver], i0.NgModuleRef]), i0.ɵmpd(1073742336, i1.CompatABTestModule, i1.CompatABTestModule, []), i0.ɵmpd(256, i0.LOCALE_ID, "ms", [])]); });
export { CompatABTestModuleNgFactory as CompatABTestModuleNgFactory };
